import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	landingPrimary: {
		id: 'landing_primary',
		defaultMessage: 'Seek and you shall find',
		description: 'Message shown to prompt users to start searching',
	},
	landingSecondaryRovo: {
		id: 'landing_secondary_rovo',
		defaultMessage:
			"Search or ask Rovo what you're looking for in your Atlassian and connected apps",
		description: 'Additional message to prompt users to start searching',
	},
	landingSecondaryUnifiedWithSAIN: {
		id: 'landing_secondary_unified_with_sain',
		defaultMessage: 'Search or ask anything across your Atlassian apps',
		description: 'Additional message to prompt users to start searching',
	},
	landingSecondaryUnifiedWithoutSAIN: {
		id: 'landing_secondary_unified_without_sain',
		defaultMessage: 'Search for anything across your Atlassian apps',
		description: 'Additional message to prompt users to start searching',
	},
	landingSecondary: {
		id: 'landing_secondary',
		defaultMessage: "Search for what you're looking for in your Atlassian and connected apps",
		description: 'Additional message to prompt users to start searching',
	},
	landingSecondaryWithAI: {
		id: 'landing_secondary_with_atlassian_intelligence',
		defaultMessage: "Search or ask what you're looking for in your Atlassian and connected apps",
		description: 'Additional message to prompt users to start searching',
	},
});
